import React, { useContext } from 'react';
import { FormDataContext } from '../../contexts/FormDataContext';
import {
  Link,
  Typography,
} from '@mui/material';
import { SectionPaper } from '../SectionPaper';
import { SectionHeading } from '../SectionHeading';
export const AccountSettings = () => {
  const {
    isSubscribed,
    currentUserEmail,
    subscribeLink,
    unsubscribeLink,
  } = useContext(FormDataContext);
    return (
    <>
      <Typography
       variant="h2"
       component="h2"
       sx={{
         overflowWrap: "break-word",
         fontSize: "2rem",
         "@media (max-width:600px)": {
           fontSize: "1.25rem"
         }
       }}
      >
        {currentUserEmail}
      </Typography>
      <SectionHeading>
        Your Subscription
      </SectionHeading>
      <SectionPaper sx={{padding: "13px 15px"}}>
        <>
          {isSubscribed
            ?
              <>
                You are currently <strong>Subscribed</strong>.
                <br/>To stop receiving job notifications, click here to <Link href={unsubscribeLink}>Unsubscribe</Link>.
              </>
            :
              <>
                You are currently <strong>Unsubscribed</strong>.
                <br/>To start receiving job notifications, click here to <Link href={subscribeLink}>Subscribe</Link>.
              </>
          }
        </>
      </SectionPaper>
    </>
  );
};